import { ensureNotNil } from "client/Misc/utils";
import { ReactElement } from "react";
import { createRoot } from "react-dom/client";
import { ContentBlock } from "../PublicPage/ContentBlock";
import { localize } from "client_legacy/ndaw/culture";
import { Anchor, FormattedText } from "client/Components";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";

const SignInPage = (): ReactElement => {
	return (
		<ContentBlock size="small">
			<h1>{localize("_SignInTitle")}</h1>

			<FormattedText
				text={localize("_SsoNotSupportedMessage")}
				thingsToWrap={[
					{
						blockId: "ClickHere",
						wrap: (x) => (
							<Anchor
								href={createUrlRelativeToEnvironment("/AdminPage/ConfigureSingleSignOn")}
							>
								{x}
							</Anchor>
						)
					}
				]}
			/>
		</ContentBlock>
	);
};
SignInPage.displayName = "SignInPage";

export function init(): void {
	createRoot(
		ensureNotNil(
			document.getElementById("sign-in-page")
		)
	)
		.render(
			<SignInPage />
		);
}
